import { render } from "./RobotmanNavbar1.vue?vue&type=template&id=761a8faf"
import script from "./RobotmanNavbar1.vue?vue&type=script&lang=js"
export * from "./RobotmanNavbar1.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__